export var copy = function (val) {
    var oInput = document.createElement('input');
    oInput.value = val;
    document.body.appendChild(oInput);
    oInput.select();
    document.execCommand("Copy");
    document.body.removeChild(oInput);
    return true;
};
